// import * as XLSX from "xlsx";
import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { FiEye, FiEyeOff } from "react-icons/fi";
import {
  Percent,
  FileText,
  FileSignature,
  Clock,
  Phone,
  UserCheck,
  IndianRupee,
  UserPlus,
  Megaphone,
  Play,
} from "lucide-react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import "./navbar.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "bootstrap-icons/font/bootstrap-icons.css";
import bankQR from "./img/bankQR.png";
import usersvg from "./img/usersvg.svg";
// import logoutsvg from './img/logout.svg'
import loginnav from "./img/loginnav.svg";
import { useLocation } from "react-router-dom";
// import miec from "./img/final3.png"
// import qr from "./img/qr.png"
// import qr1 from "./img/mdqr.png"
import contactUs from "./img/contact.svg";
import welcome from "./img/hands.png";
import login from "./img/newLogin.svg";
import passwordReset from "./img/password-reset.svg";
import signup from "./img/signup.svg";
import aboutUsImage from "./img/aboutus.svg";
import smlsoc from "./img/logo.png";
import mobilesmlsoc from "./img/mobile.png";
import axios from "axios";
import logo from "./img/mobile.png";
import paymentHome from "./img/payment/paymentHome.jpeg";
import paymentName from "./img/payment/paymentName.jpeg";
import paymentScanner from "./img/payment/paymentScanner.jpeg";
// import { saveAs } from "file-saver";
let userName = "";
let fatherName = "";
let accountNo = "";
const images = [];
let userData = {};
let isMemberLoggedIn = false;
let isAdminLoggedIn = false;
const sizeOf = (data) => {
  return data.length;
};

// ✅ NEW: token helpers — read the JWT saved at login and build the Authorization header
const getToken = () => {
  try {
    return JSON.parse(sessionStorage.getItem("token"));
  } catch {
    return null;
  }
};

const authHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

function ResetPassword() {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleResetPassword = async () => {
    if (formData.newPassword !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const accountNo = JSON.parse(sessionStorage.getItem("accountNo"));

    const res = await fetch(
      "https://smlsoc-backend-3.onrender.com/resetPassword",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeader(), // ✅ NEW
        },
        body: JSON.stringify({
          accountNo,
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        }),
      },
    );

    const data = await res.json();

    if (res.ok) {
      alert("Password changed successfully");

      sessionStorage.setItem("isMemberLoggedIn", JSON.stringify(true));

      navigate("/memberDetails");
    } else {
      alert(data.message);
    }
  };

  const handleSkip = async () => {
    const accountNo = JSON.parse(sessionStorage.getItem("accountNo"));
    await fetch("https://smlsoc-backend-3.onrender.com/skipPasswordChange", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ accountNo }),
    });

    sessionStorage.setItem("isMemberLoggedIn", JSON.stringify(true));

    navigate("/memberDetails");
  };

  return (
    <div className="container mt-5">
      <div className="card p-4">
        <h3>Change Password</h3>

        <div className="mb-3">
          <label>Current Password</label>
          <input
            type="password"
            name="oldPassword"
            className="form-control"
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>New Password</label>
          <input
            type="password"
            name="newPassword"
            className="form-control"
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            className="form-control"
            onChange={handleChange}
          />
        </div>

        <div className="d-flex gap-2">
          <button className="btn btn-success" onClick={handleResetPassword}>
            Change Password
          </button>

          <button className="btn btn-secondary" onClick={handleSkip}>
            Login Without Changing
          </button>
        </div>
      </div>
    </div>
  );
}
// const downloadExcel = () => {
//   const worksheet = XLSX.utils.json_to_sheet(memberData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");
//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//   saveAs(blob, "member_ledger.xlsx");
// };

function UploadCSV() {
  const [currentPage, setCurrentPage] = useState(1);
  const [showMembersPanel, setShowMembersPanel] = useState(true);
  const [showMemberSection, setShowMemberSection] = useState(true);
  const [showUploadSection, setShowUploadSection] = useState(true);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [showTransactionUpload, setShowTransactionUpload] = useState(true);
  const [showMemberUpload, setShowMemberUpload] = useState(false);
  const [showLoginUpload, setShowLoginUpload] = useState(false);
  const [showAddMember, setShowAddMember] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [members, setMembers] = useState([]);
  const [newAccountNo, setNewAccountNo] = useState("");
  const [newAadharNo, setNewAadharNo] = useState("");
  const [newMemberName, setNewMemberName] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const showNotification = (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  };
  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const res = await axios.get(
        "https://smlsoc-backend-3.onrender.com/admin/members",
        {
          headers: authHeader(), // ✅ NEW
        },
      );

      setMembers(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const toggleStatus = async (accountNumber, active) => {
    try {
      await axios.post(
        "https://smlsoc-backend-3.onrender.com/admin/member/status",
        {
          accountNumber,
          active: active === 1 ? 0 : 1,
        },
        { headers: authHeader() }, // ✅ NEW
      );

      fetchMembers();
    } catch (err) {
      console.error(err);
      alert("Unable to update status");
    }
  };
  const addMember = async () => {
    try {
      if (!newAccountNo || !newAadharNo || !newMemberName) {
        alert("Please fill all fields");
        return;
      }
      if (!/^\d{12}$/.test(newAadharNo)) {
        showNotification("Aadhaar number must be exactly 12 digits");
        return;
      }
      await axios.post(
        "https://smlsoc-backend-3.onrender.com/admin/member/create",
        {
          accountNumber: newAccountNo,
          aadharNumber: newAadharNo,
          memberName: newMemberName,
        },
        { headers: authHeader() }, // ✅ NEW
      );

      showNotification("Member created successfully");

      setNewAccountNo("");
      setNewAadharNo("");

      fetchMembers();
    } catch (err) {
      console.error(err);

      showNotification("Unable to create member");

      // setShowPopup(true);
    }
  };
  isAdminLoggedIn = JSON.parse(sessionStorage.getItem("isAdminLoggedIn"));
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleTransactiosUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file); // ✅ Field name must match backend

    try {
      await axios.post(
        "https://smlsoc-backend-3.onrender.com/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...authHeader(), // ✅ NEW
          },
        },
      );
      alert("File uploaded successfully!");
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };
  const handleMemberDetailsUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file); // ✅ Field name must match backend

    try {
      await axios.post(
        "https://smlsoc-backend-3.onrender.com/memberUpload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...authHeader(), // ✅ NEW
          },
        },
      );
      alert("File uploaded successfully!");
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };
  const handleLoginDetailUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file); // ✅ Field name must match backend

    try {
      const res = await axios.post(
        "https://smlsoc-backend-3.onrender.com/loginUpload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...authHeader(), // ✅ NEW
          },
        },
      );
      alert(res.data);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };
  if (isAdminLoggedIn) {
    const filteredMembers = members.filter((member) => {
      const search = searchText.toLowerCase();

      return (
        member.accountNumber?.toString().toLowerCase().includes(search) ||
        (member.memberName || "").toLowerCase().includes(search) ||
        member.aadharNumber?.toString().includes(search)
      );
    });
    const sortedMembers = [...filteredMembers].sort((a, b) => {
      if (!sortField) return 0;

      const aValue = a[sortField] ?? "";
      const bValue = b[sortField] ?? "";

      if (sortDirection === "asc") {
        return aValue
          .toString()
          .localeCompare(bValue.toString(), undefined, { numeric: true });
      }

      return bValue
        .toString()
        .localeCompare(aValue.toString(), undefined, { numeric: true });
    });

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;

    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const handleSort = (field) => {
      if (sortField === field) {
        setSortDirection(sortDirection === "asc" ? "desc" : "asc");
      } else {
        setSortField(field);
        setSortDirection("asc");
      }
    };
    const currentMembers = sortedMembers.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );

    const totalPages = Math.ceil(filteredMembers.length / recordsPerPage);
    return (
      <>
        <div className="admin-card">
          <div
            className="admin-card-header"
            onClick={() => setShowUploadSection(!showUploadSection)}
          >
            <div>
              <h4>📁 Data Upload Center</h4>
              <small>Upload CSV files</small>
            </div>

            <span
              className={`accordion-icon ${showUploadSection ? "open" : ""}`}
            >
              ▼
            </span>
          </div>

          <div className={`admin-card-body ${showUploadSection ? "open" : ""}`}>
            <div className="upload-cards">
              {/* Transaction Upload */}
              <div className="upload-card">
                <div className="upload-icon">📊</div>

                <h4>Transaction CSV</h4>
                <p>Upload member transaction records</p>

                <input
                  type="file"
                  onChange={handleFileChange}
                  className="form-control mb-3"
                />

                <button
                  onClick={handleTransactiosUpload}
                  className="btn btn-success w-100"
                >
                  Upload File
                </button>
              </div>

              {/* Member Details Upload */}
              <div className="upload-card">
                <div className="upload-icon">👥</div>

                <h4>Member Details</h4>
                <p>Upload member master data</p>

                <input
                  type="file"
                  onChange={handleFileChange}
                  className="form-control mb-3"
                />

                <button
                  onClick={handleMemberDetailsUpload}
                  className="btn btn-success w-100"
                >
                  Upload File
                </button>
              </div>

              {/* Login Details Upload */}
              <div className="upload-card">
                <div className="upload-icon">🔐</div>

                <h4>Login Details</h4>
                <p>Upload login credentials</p>

                <input
                  type="file"
                  onChange={handleFileChange}
                  className="form-control mb-3"
                />

                <button
                  onClick={handleLoginDetailUpload}
                  className="btn btn-success w-100"
                >
                  Upload File
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="member-panel">
          <div
            className="member-panel-header"
            onClick={() => setShowMembersPanel(!showMembersPanel)}
          >
            <div>
              <h4>👥 Member Management</h4>
              <small>Search, Add and Manage Members</small>
            </div>

            <span
              className={`member-panel-arrow ${showMembersPanel ? "open" : ""}`}
            >
              ▼
            </span>
          </div>

          <div
            className={`member-panel-body ${showMembersPanel ? "open" : ""}`}
          >
            <div className="member-toolbar">
              <div className="member-search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="🔍 Search by Account Number, Name or Aadhaar"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>

              {/* <button
                className="btn member-add-btn"
                onClick={() => setShowAddMemberModal(true)}
              >
                + Add Member
              </button> */}
            </div>
            <div className="member-table-card">
              <div className="member-table-header">
                <div>
                  <h5>Members</h5>
                  <span>{filteredMembers.length} Records Found</span>
                </div>
                <button
                  className="member-add-btn"
                  onClick={() => setShowAddMemberModal(true)}
                >
                  + Add Member
                </button>
              </div>
              {showAddMemberModal && (
                <div className="member-modal">
                  <div className="member-modal-header">
                    <div>
                      <h4>Add New Member</h4>
                      <span>Create a member account</span>
                    </div>

                    <button
                      className="member-modal-close"
                      onClick={() => setShowAddMemberModal(false)}
                    >
                      ✕
                    </button>
                  </div>

                  <div className="member-modal-body">
                    <div className="input-group-modern">
                      <label>Account Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newAccountNo}
                        onChange={(e) => setNewAccountNo(e.target.value)}
                      />
                    </div>

                    <div className="input-group-modern">
                      <label>Member Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newMemberName}
                        onChange={(e) => setNewMemberName(e.target.value)}
                      />
                    </div>

                    <div className="input-group-modern">
                      <label>Aadhaar Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newAadharNo}
                        onChange={(e) => setNewAadharNo(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="member-modal-footer">
                    <button
                      className="member-btn-cancel"
                      onClick={() => setShowAddMemberModal(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="member-btn-save"
                      onClick={() => {
                        addMember();
                        setShowAddMemberModal(false);
                      }}
                    >
                      Add Member
                    </button>
                  </div>
                </div>
              )}
              <div className="member-table-wrapper">
                <table className="member-table">
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("accountNumber")}>
                        Account Number
                        {sortField === "accountNumber" &&
                          (sortDirection === "asc" ? " ▲" : " ▼")}
                      </th>

                      <th onClick={() => handleSort("memberName")}>
                        Member Name
                        {sortField === "memberName" &&
                          (sortDirection === "asc" ? " ▲" : " ▼")}
                      </th>

                      <th onClick={() => handleSort("aadharNumber")}>
                        Aadhaar Number
                        {sortField === "aadharNumber" &&
                          (sortDirection === "asc" ? " ▲" : " ▼")}
                      </th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentMembers.length > 0 ? (
                      currentMembers.map((member) => (
                        <tr key={member.accountNumber}>
                          <td>{member.accountNumber}</td>

                          <td>{member.memberName || "-"}</td>

                          <td>{member.aadharNumber}</td>

                          <td>
                            <span
                              className={
                                member.active === 1
                                  ? "status-active"
                                  : "status-inactive"
                              }
                            >
                              {member.active === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>

                          <td>
                            <button
                              className={
                                member.active === 1
                                  ? "member-action-btn deactivate"
                                  : "member-action-btn activate"
                              }
                              onClick={() =>
                                toggleStatus(
                                  member.accountNumber,
                                  member.active,
                                )
                              }
                            >
                              {member.active === 1 ? "Deactivate" : "Activate"}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                          No Members Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="member-pagination">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    Previous
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Popup
          isOpen={showPopup}
          onClose={() => setShowPopup(false)}
          message={popupMessage}
        />
      </>
    );
  } else {
    return (
      <div className="card text-center">
        <div className="card-body">
          <h5 className="card-title">Please Login from Admin To Uplaod Data</h5>
          <Link to="/adminLogin" className="btn btn-success loginbtn">
            Login
          </Link>
        </div>
      </div>
    );
  }
}
for (let i = 1; i <= 9; i++) {
  images.push(require(`./img/gallery/DSC${i}.jpg`));
}
let memberData = [];
// Components
const data = [
  { id: 1, name: "Mr. Dhananjay Kumar", designation: "President" },
  { id: 2, name: "Mr. Deepak Gupta", designation: "Vice President" },
  { id: 3, name: "Mr. Ritvik Gupta", designation: "Hony. Secretary" },
  { id: 4, name: "Mr. Vipin Bansal", designation: "Treasurer" },
  { id: 5, name: "Mr. Satish Kumar", designation: "Executive Member" },
  { id: 6, name: "Smt. Aanchal Gupta", designation: "Executive Member" },
  { id: 7, name: "Smt. Dharamsheela Verma", designation: "Executive Member" },
];
const interestRateData = [
  { rate: "7% P.A", label: "Compulsory Deposit" },
  { rate: "7% P.A", label: "Optional Deposit (O.D.)" },
  { rate: "15% P.A", label: "Ordinary Loan" },
  { rate: "15% P.A", label: "Emergency Loan" },
];

const silentFeatures = [
  {
    label: "1000+",
    content: "Crossed an exciting milestone with 1000+ Members Registered",
  },
  {
    label: "12% Interest Rate",
    content:
      "Interest more than Banks offered in short-term and medium-term RDs & FDs",
  },
  {
    label: "Hassle free Accounting",
    content:
      "Experience Quick Account activation with personalized user onboarding",
  },
  {
    label: "Zero Tax Deduction",
    content: "No TDS is applicable on the interest earned on the deposits.",
  },
];

function ImageGallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <div className="gallery-container">
      <div className="carousel single-photo-carousel">
        <button className="arrow plain left" onClick={handlePrev}>
          ‹
        </button>

        <img
          src={images[currentIndex]}
          alt={`Carousel ${currentIndex}`}
          className="carousel-img single-img"
          onClick={() => setSelectedImage(images[currentIndex])}
        />

        <button className="arrow plain right" onClick={handleNext}>
          ›
        </button>
      </div>

      <div className="image-grid">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Gallery ${idx}`}
            className="grid-img"
            onClick={() => setSelectedImage(img)}
          />
        ))}
      </div>

      {selectedImage && (
        <div className="overlay" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Enlarged" className="enlarged-img" />
        </div>
      )}
    </div>
  );
}

function Navbar() {
  let logInformation = JSON.parse(sessionStorage.getItem("isMemberLoggedIn"));
  isAdminLoggedIn = JSON.parse(sessionStorage.getItem("isAdminLoggedIn"));
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const isMemberLogged = logInformation ? logInformation : false;
  userName = userData ? userData.userName : "";
  fatherName = userData ? userData.fatherName : "";
  const [isLoanOpen, setLoanOpen] = useState(false);
  const [isServicesOpen, setServicesOpen] = useState(false);

  const isMobile = () => window.innerWidth <= 991;
  const [isNavbarOpen, setNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setNavbarOpen((prev) => !prev) &&
      setLoanOpen(false) &&
      setServicesOpen(false);
  };
  const toggleDropdown = (isTargetOpen, setTarget, setOther) => {
    if (isMobile()) {
      setOther(false);
      setTarget(!isTargetOpen);
    }
  };
  const handleNavClose = () => {
    setNavbarOpen(false) && setLoanOpen(false) && setServicesOpen(false);
  };
  return (
    <nav className="navbar navbar-expand-xl navbar-dark navbar-item fixed-top shadow z-50 ">
      <div className="container-fluid">
        <Link className="navbar-brand d-none d-md-block" to="/">
          <img src={smlsoc} alt="smlsoc" className="logo"></img>
        </Link>
        <Link className="navbar-brand d-block d-md-none" to="/">
          <img src={mobilesmlsoc} alt="mobilesmlsoc" className="logo"></img>
        </Link>
        {(isMemberLogged || isAdminLoggedIn) && (
          <div className="mobileview user-toggle-mobile">
            <div className="d-block d-xl-none">
              {(isMemberLogged || isAdminLoggedIn) && (
                <div className="dropdown">
                  <button
                    className="btn btn-mobile"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <p className="m-auto">
                      <img className="userimg" src={usersvg} alt="u" />{" "}
                      {userName}
                    </p>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end user-dropdown">
                    {isMemberLogged && (
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/memberDetails"
                        >
                          Member Ledger
                        </Link>
                      </li>
                    )}
                    {isAdminLoggedIn && (
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center"
                          to="/upload"
                        >
                          Upload
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        className="dropdown-item d-flex align-items-center"
                        to="/logout"
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="vertical-separator" />
            <div>
              <button
                className={`navbar-toggler-custom ${isNavbarOpen ? "open" : ""}`}
                onClick={toggleNavbar}
                aria-label="Toggle navigation"
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        )}
        {!(isMemberLogged || isAdminLoggedIn) && (
          <button
            className={`navbar-toggler-custom ${isNavbarOpen ? "open" : ""}`}
            onClick={toggleNavbar}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>
        )}
        <div className={`navbar-collapse-custom ${isNavbarOpen ? "show" : ""}`}>
          <div
            className={`navbar-separator ${isNavbarOpen ? "visible" : ""}`}
          />
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link
                className="custom-nav fs-5 gap-5 glow-on-hover"
                to="/"
                onClick={() => setNavbarOpen(false)}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="custom-nav fs-5 glow-on-hover"
                to="/about"
                onClick={() => setNavbarOpen(false)}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="custom-nav fs-5 glow-on-hover"
                to="/Circulars"
                onClick={() => setNavbarOpen(false)}
              >
                Circulars
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link className="custom-nav fs-5  glow-on-hover" to="/committee" onClick={() => setNavbarOpen(false)}>Committee</Link>
            </li> */}

            {/* Loan Dropdown */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() =>
                !isMobile() && (setLoanOpen(true), setServicesOpen(false))
              }
              onMouseLeave={() => !isMobile() && setLoanOpen(false)}
              onClick={() =>
                toggleDropdown(isLoanOpen, setLoanOpen, setServicesOpen)
              }
            >
              <span className="custom-nav fs-5 glow-on-hover">Loan</span>
              {isLoanOpen && (
                <ul className="fade-in-nav dropdown-menu-custom show">
                  <li>
                    <Link
                      to="/loan/emergencyLoan"
                      className="dropdown-item-custom glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Emergency Loan
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/loan/personalLoan"
                      className="dropdown-item-custom glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Personal/Regular Loan
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/loan/loanAgainstDeposit"
                      className="dropdown-item-custom glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Loan Against Deposit
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Services Dropdown */}
            <li
              className="nav-item dropdown"
              onMouseEnter={() =>
                !isMobile() && (setServicesOpen(true), setLoanOpen(false))
              }
              onMouseLeave={() => !isMobile() && setServicesOpen(false)}
              onClick={() =>
                toggleDropdown(isServicesOpen, setServicesOpen, setLoanOpen)
              }
            >
              <span className="custom-nav fs-5  glow-on-hover">Services</span>
              {isServicesOpen && (
                <ul className="fade-in-nav dropdown-menu-custom show">
                  <li>
                    <Link
                      to="/services/fixedDeposit"
                      className="dropdown-item-custom mb-2 glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Fixed Deposit (FD)
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services/recurringDeposit"
                      className="dropdown-item-custom mb-2 glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Recurring Deposit (RD)
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services/savingDeposit"
                      className="dropdown-item-custom mb-2 glow-on-hover"
                      onClick={handleNavClose}
                    >
                      Saving Deposit
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li className="nav-item">
              <Link
                className="custom-nav fs-5 glow-on-hover"
                to="/contact"
                onClick={() => setNavbarOpen(false)}
              >
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="custom-nav d-xl-none fs-5 glow-on-hover"
                to="/login"
                onClick={() => setNavbarOpen(false)}
              >
                Login/Signup
              </Link>
            </li>
          </ul>
        </div>
        {!isMobile() && (isMemberLogged || isAdminLoggedIn) && (
          <div className="d-none d-xl-block">
            <div className="dropdown">
              <button
                className="btn user-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <p className="m-auto">
                  <img className="userimg" src={usersvg} alt="u" /> {userName}
                </p>
              </button>
              <ul className="dropdown-menu dropdown-menu-end user-dropdown">
                {isMemberLogged && (
                  <li>
                    <Link
                      className="dropdown-item d-flex align-items-center"
                      to="/memberDetails"
                    >
                      Member Ledger
                    </Link>
                  </li>
                )}
                {isAdminLoggedIn && (
                  <li>
                    <Link
                      className="dropdown-item d-flex align-items-center"
                      to="/upload"
                    >
                      Upload
                    </Link>
                  </li>
                )}
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center"
                    to="/logout"
                  >
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}
        {!(isMemberLogged || isAdminLoggedIn) && (
          <div className="loginbutton">
            <Link
              className="btn rounded-pill px-4 d-flex align-items-center btn-rounded btn-hover-highlight hover-effect-btn"
              to="/login"
            >
              <img
                width="35"
                height="35"
                className="me-2"
                alt="login"
                src={loginnav}
              ></img>
              <span className="no-break-text fs-5 me-20">Login/Signup</span>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}

function InterestRates() {
  return (
    <div className="interest-container-outer">
      <div className="interest-container">
        <h2 className="section-title">Interest rates on Loans And Deposits</h2>
        <div className="interest-grid">
          {interestRateData.map((item, index) => (
            <div key={index} className="interest-card">
              <div className="interest-rate">{item.rate}</div>
              <div className="interest-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function Loader() {
  return (
    <div className="loader-overlay">
      <div className="loader-wrapper">
        <div className="spinner-ring"></div>
        <img src={logo} alt="Logo" className="loader-logo" />
      </div>
    </div>
  );
}
function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  }, [navigate]);

  return null;
}
function useAutoLogout(timeout = 5 * 60 * 1000) {
  const navigate = useNavigate();
  const timer = useRef();

  const resetTimer = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach((event) => window.addEventListener(event, handleActivity));
    resetTimer(); // Start timer on mount

    return () => {
      clearTimeout(timer.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
    };
  });
}

function MemberDetails() {
  accountNo = JSON.parse(sessionStorage.getItem("accountNo"));
  userName = JSON.parse(sessionStorage.getItem("userName"));
  fatherName = JSON.parse(sessionStorage.getItem("fatherName"));
  useAutoLogout();
  const todayDate = new Date();

  const fyStartYear =
    todayDate.getMonth() >= 3 // April = 3
      ? todayDate.getFullYear()
      : todayDate.getFullYear() - 1;

  const defaultFromDate = `${fyStartYear}-04-01`;
  const today = todayDate.toISOString().split("T")[0];

  const isMemberLoggedIn = JSON.parse(
    sessionStorage.getItem("isMemberLoggedIn"),
  );

  const [memberData, setMemberData] = useState(
    JSON.parse(sessionStorage.getItem("memberData")) || [],
  );
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(today);
  const [dateError, setDateError] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);

  // Compute min allowed date (2 years ago from today)
  const getTwoYearsAgoDate = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 2);
    return d.toISOString().split("T")[0];
  };

  // const today = new Date().toISOString().split("T")[0];
  const minAllowedDate = getTwoYearsAgoDate();

  const validateDates = () => {
    if (!fromDate || !toDate) {
      setDateError("Please select both From and To dates.");
      return false;
    }
    if (fromDate < minAllowedDate) {
      setDateError(
        `Statements older than 2 years cannot be generated. Please select a From Date on or after ${minAllowedDate}.`,
      );
      return false;
    }
    if (fromDate > toDate) {
      setDateError("From Date cannot be later than To Date.");
      return false;
    }
    if (toDate > today) {
      setDateError("To Date cannot be a future date.");
      return false;
    }
    setDateError("");
    return true;
  };

  const handleGenerateStatement = async () => {
    if (!validateDates()) return;

    setLoading(true);
    setHasGenerated(false);
    try {
      const response = await fetch(
        `https://smlsoc-backend-3.onrender.com/member/${accountNo}?fromDate=${fromDate}&toDate=${toDate}`,
        { headers: authHeader() }, // ✅ NEW
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setMemberData(data);
      setHasGenerated(true);
    } catch (error) {
      setDateError("Failed to fetch statement. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = () => {
    if (!memberData?.length) return;

    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a3",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Header
      doc.setFontSize(18);
      doc.text(
        "Shree Maa Laxmi Cooperative Thrift and Credit Society Ltd.",
        pageWidth / 2,
        15,
        { align: "center" },
      );

      doc.setFontSize(14);
      doc.text(
        "1/4704, Balbir Nagar Ext, Street 4c, Shahdara, Delhi - 110032 ",
        pageWidth / 2,
        23,
        {
          align: "center",
        },
      );

      doc.setFontSize(18);
      doc.text("Member Ledger", 14, 32);

      doc.setFontSize(11);
      doc.text(`Member Account : ${accountNo}`, 14, 40);
      doc.text(`Member Name : ${userName}`, 14, 45.9);
      doc.text(`Father's Name / Husband's Name : ${fatherName}`, 14, 52);

      doc.text(
        `Date : ${new Date().toLocaleDateString("en-GB")}`,
        pageWidth - 14,
        52,
        { align: "right" },
      );

      // Table data
      const columns = Object.keys(memberData[0]);

      const rows = memberData.map((row) =>
        columns.map((col) => row[col] ?? ""),
      );

      // Generate table
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: 60,

        styles: {
          fontSize: 8,
          cellPadding: 2,
          overflow: "linebreak",
          cellWidth: "wrap",
        },

        headStyles: {
          fontStyle: "bold",
        },

        horizontalPageBreak: true,
        showHead: "everyPage",
      });

      // Position after table
      let finalY = doc.lastAutoTable.finalY;
      let y = finalY + 5;

      // If footer won't fit, add new page
      if (y > pageHeight - 30) {
        doc.addPage();
        y = 30;
      }

      // Signature labels
      doc.setFontSize(10);

      doc.text(
        "Note:- This statement is computer generated and therefore does not require any signature or seal.",
        15,
        y + 5,
      );

      doc.text("End of the Line", pageWidth - 15, y + 5, { align: "right" });

      doc.save(`${userName.split(" ")[0]}-${accountNo}-memberLedger.pdf`);
    } catch (err) {
      console.error("PDF generation error:", err);
    }
  };

  if (!isMemberLoggedIn) {
    return (
      <div className="card text-center">
        <div className="card-body">
          <h5 className="card-title">Please Login To See Details</h5>
          <Link to="/login" className="btn btn-success loginbtn">
            Login
          </Link>
        </div>
      </div>
    );
  }

  const hasData = memberData.length > 0;
  const columns = hasData ? Object.keys(memberData[0]) : [];

  return (
    <>
      {/* Member Info */}
      <div className="table-container-details">
        <h2>Member Details</h2>
        <div className="member-deails">
          <p>
            <b>Account Number: </b>
            {accountNo}
          </p>
          <p>
            <b>Name: </b>
            {userName}
          </p>
          <p>
            <b>Father's Name: </b>
            {fatherName}
          </p>
        </div>
      </div>

      {/* Date Filter */}
      <div className="table-container">
        <h2 className="table-title">Member Ledger</h2>

        {/* 2-year restriction notice */}
        <div className="alert alert-info py-2 mb-3" role="alert">
          <small>
            ℹ️ Statements can only be generated for transactions within the last{" "}
            <strong>2 years</strong>.
          </small>
        </div>

        <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
          <div>
            <label className="form-label fw-semibold mb-1">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              min={minAllowedDate}
              max={today}
              onChange={(e) => {
                setFromDate(e.target.value);
                setDateError("");
              }}
            />
          </div>
          <div>
            <label className="form-label fw-semibold mb-1">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              min={fromDate || minAllowedDate}
              max={today}
              onChange={(e) => {
                setToDate(e.target.value);
                setDateError("");
              }}
            />
          </div>
          <div className="d-flex gap-2">
            <button
              onClick={handleGenerateStatement}
              className="btn btn-success"
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate Statement"}
            </button>
            {hasGenerated && hasData && (
              <button onClick={downloadPDF} className="btn btn-primary">
                Download PDF
              </button>
            )}
          </div>
        </div>

        {/* Error / Validation Message */}
        {dateError && (
          <div className="alert alert-danger py-2" role="alert">
            <small>⚠️ {dateError}</small>
          </div>
        )}

        {/* Table */}
        {hasGenerated && (
          <div className="table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  {columns.map((col, idx) => (
                    <th key={idx}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  memberData.map((member, index) => (
                    <tr key={index}>
                      {columns.map((col, idx) => (
                        <td key={idx}>
                          {member[col] === 0 ? "" : member[col]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={columns.length || 1}
                      style={{ textAlign: "center" }}
                    >
                      No Transactions found for the selected date range.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

function ManagingCommittee() {
  return (
    <div className="container committee">
      <div className="table-container">
        <h2 className="table-title">List of Managing Committee</h2>
        <table className="custom-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
            </tr>
          </thead>
          <tbody>
            {data.map((member, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{member.name}</td>
                <td>{member.designation}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// Pages
function Home() {
  return (
    <div className="container">
      <BankDetails />
      <div className="welcome">
        <div className="fade-in delay-img welpad">
          <img src={welcome} alt="welcome" className="welcomeimg" />
        </div>
        <div className="jumbotron p-4 fade-in delay-text">
          <h1 className="display-6">Welcome To Shree Maa Laxmi Corp society</h1>
          <p className="lead">
            Shree Maa Laxmi Corp society is a Thrift & Credit Cooperative
            Society The primary objective of the Society is to uplift the social
            and economic conditions of its members by promoting saving habits.
            The products of the Society are in the shape of Fixed Deposits,
            Recurring Deposits, Saving Accounts, Loans etc.
          </p>
        </div>
      </div>
      {/* <NoticeBoard /> */}
      <PaymentProcess />
      <InterestRates />
    </div>
  );
}

function About() {
  return (
    <div className="container aboutUs">
      <div>
        <div className="row align-items-center">
          {/* Text Column */}
          <div className="col-md-7">
            <h2 className="fw-bold mb-4">About Us</h2>
            <p>
              Shree Maa Laxmi Cooperative Thrift & Credit Society Limited was
              founded by Mr. Dhananjay Kumar and Mr. Rajesh Gupta. The Society
              is registered under the Delhi Cooperative Societies (DCS) Act,
              2003, with registration number 10284. It was officially recognized
              by the Registrar of Cooperative Societies, Delhi, in November
              2011.
            </p>

            <p>
              Our mission is to improve the financial well-being of our members
              by promoting savings and offering reliable financial services. We
              provide Fixed Deposits, Recurring Deposits, Saving Accounts, and
              Loan facilities to meet a variety of financial needs.
              <br />
              <br />
              Based in Delhi, the Society operates according to the DCS act 2003
              and RCS Rule-2007, which define clear rules, standards, and
              ethical practices.
            </p>

            <p>
              As a compliant organization under the Delhi State Cooperative
              Society Act, 2003, Shree Maa Laxmi Cooperative works exclusively
              with its members. All profits are reinvested to support the
              community through loans and development programs, in line with the
              Cooperative Act, Rules, and Bye-laws.
              <br />
              <br />
              The Registrar of Cooperative Societies (RCS), Delhi, serves as our
              official regulator, guiding and supervising all operations.
            </p>
          </div>

          {/* Image Column */}
          <div className="col-md-5 text-center">
            <img
              src={aboutUsImage}
              alt="About Us Illustration"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="interest-container ">
          <h2 className="section-title">
            Interest rates on Loans And Deposits
          </h2>
          <br></br>
          <div className="interest-grid">
            {silentFeatures.map((item, index) => (
              <div key={index} className="interest-card">
                <div className="interest-rate mb-3">{item.label}</div>
                <div className="interest-label">{item.content}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Downloads() {
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleUpload = () => {
    if (selectedFile) {
      alert(`Uploaded: ${selectedFile.name}`);
      setSelectedFile(null);
    }
  };

  return (
    <>
      <h4 className="text-center">Upload a File</h4>
      <div className="container download mt-4">
        <input
          type="file"
          onChange={handleFileChange}
          className="form-control mb-2"
        />
        <button onClick={handleUpload} className="btn btn-success">
          Upload
        </button>
      </div>
    </>
  );
}

function Popup({ isOpen, onClose, message }) {
  return (
    <div className={`popup-overlay ${isOpen ? "show" : ""}`}>
      <div className="popup-box center">
        <div className="popup-content">
          <p className="mb-3">{message}</p>
          <button className="btn btn-danger w-100" onClick={onClose}>
            Close
          </button>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
}

function Gallery() {
  return (
    <div className="container gallery">
      <ImageGallery />
    </div>
  );
}

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordScreen, setIsPasswordScreen] = useState(false);
  const [viewMode, setViewMode] = useState("LOGIN"); // LOGIN | REGISTER | PASSWORD
  const [passwordMode, setPasswordMode] = useState(""); // FIRST_LOGIN | RESET
  const [resetData, setResetData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    accountNo: "",
    phoneNo: "",
    password: "",
  });
  const [popupMessage, setPopupMessage] = useState("");
  const [error, setError] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const showPopup = (msg) => {
    setPopupMessage(msg);
    setPopupOpen(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch("https://smlsoc-backend-3.onrender.com/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const loginResponse = await res.json();
      userData = loginResponse;
      accountNo = loginResponse.accountNo;
      if (!res.ok) throw new Error(loginResponse.message || "Login failed");
      if (accountNo != null) {
        sessionStorage.setItem("userData", JSON.stringify(userData));
        sessionStorage.setItem("accountNo", JSON.stringify(accountNo));
        sessionStorage.setItem("token", JSON.stringify(loginResponse.token)); // ✅ NEW: save JWT from login response
        sessionStorage.setItem(
          "userName",
          JSON.stringify(loginResponse.userName),
        );
        sessionStorage.setItem(
          "fatherName",
          JSON.stringify(loginResponse.fatherName),
        );
        const memberAccountNo = accountNo;
        try {
          if (loginResponse.isFirstLogin && !loginResponse.passwordSkip) {
            setLoading(false);

            setPasswordMode("FIRST_LOGIN");
            setViewMode("PASSWORD");

            return;
          }

          isMemberLoggedIn = true;
          sessionStorage.setItem(
            "isMemberLoggedIn",
            JSON.stringify(isMemberLoggedIn),
          );
          navigate("/memberDetails");
        } catch (err) {
          setLoading(false);
          console.error("Error fetching user data:", err);
        }
      } else {
        setLoading(false);
        showPopup("Unable to Get details");
        navigate("/login");
      }
    } catch (err) {
      setLoading(false);
      showPopup(err.message || "Unable to login");
    }
  };
  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch("https://smlsoc-backend-3.onrender.com/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Signup failed");
    } catch (err) {
      setLoading(false);
      showPopup(err.message || "Unable to signup");
    }
  };

  return (
    <>
      <div className="auth-container">
        <div
          className={`card-wrapper ${viewMode !== "LOGIN" ? "flipped" : ""}`}
        >
          {/* LOGIN FORM */}
          <div className="card-face card-front">
            <div className="row align-items-center">
              <div className="col-md-6 d-none d-md-block">
                <img src={login} className="img-fluid" alt="Login" />
              </div>
              <div className="col-md-6 col-12 p-4">
                <h3 className="mb-4 text-center text-md-start">Login</h3>
                <form onSubmit={handleLogin}>
                  <div className="mb-3">
                    <label>Account No</label>
                    <input
                      type="text"
                      name="accountNo"
                      className="form-control"
                      value={formData.accountNo}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3 position-relative">
                    <label>Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control pe-5"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />

                    {/* Eye Icon */}
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "30px",
                        cursor: "pointer",
                        color: "black",
                        fontSize: "1.2rem",
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                        style={{
                          transition: "opacity 0.3s ease",
                          fontSize: "15px",
                          display: "flex",
                          margin: "0",
                        }}
                      ></i>
                    </span>
                  </div>
                  {error && <div className="text-danger mb-3">{error}</div>}
                  <button className="btn btn-primary w-100" type="submit">
                    Login
                  </button>
                  <p
                    className="text-center mt-3 text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPasswordMode("RESET");
                      setViewMode("PASSWORD");
                    }}
                  >
                    Forgot/Change Password?
                  </p>
                  {/* <p className="text-center mt-3 small">
                    Don’t have an account?{' '}
                    <span className="text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                      setFormData({ accountNo: '', phoneNo: "", password: '' });
                      setError('');
                      setViewMode("REGISTER");
                    }}>Register</span>
                  </p> */}
                </form>
              </div>
            </div>
          </div>

          <div className="card-face card-back">
            {/* {viewMode === "REGISTER" && (

              <div className="row g-0 align-items-center">

                <div className="col-md-6 d-none d-md-block">
                  <img
                    src={signup}
                    className="img-fluid"
                    alt="Signup"
                  />
                </div>

                <div className="col-md-6 col-12 p-4">

                  <h3 className="mb-4">
                    Register
                  </h3>

                  <form onSubmit={handleSignup}>

                    <div className="mb-3">
                      <label>Account No</label>
                      <input
                        type="text"
                        name="accountNo"
                        className="form-control"
                        value={formData.accountNo}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label>Phone No</label>
                      <input
                        type="text"
                        name="phoneNo"
                        className="form-control"
                        value={formData.phoneNo}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label>Password</label>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-success w-100"
                    >
                      Sign Up
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-dark w-100 mt-2"
                      onClick={() => {
                        setViewMode("LOGIN");
                      }}
                    >
                      Back To Login
                    </button>

                  </form>
                </div>

              </div>
            )} */}

            {viewMode === "PASSWORD" && (
              <div className="row g-0 align-items-center">
                <div className="col-md-6 d-none d-md-block">
                  <img
                    src={passwordReset}
                    className="img-fluid"
                    alt="Password"
                  />
                </div>

                <div className="col-md-6 col-12 p-4">
                  <h3 className="mb-4">
                    {passwordMode === "FIRST_LOGIN"
                      ? "Change Password"
                      : "Reset Password"}
                  </h3>

                  {passwordMode === "RESET" && (
                    <div className="mb-3">
                      <label>Account Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.accountNo}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            accountNo: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}

                  {(passwordMode === "FIRST_LOGIN" ||
                    passwordMode === "RESET") && (
                    <div className="mb-3">
                      <label>Current Password</label>
                      <input
                        type="password"
                        className="form-control"
                        value={resetData.oldPassword}
                        onChange={(e) =>
                          setResetData({
                            ...resetData,
                            oldPassword: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}

                  <div className="mb-3">
                    <label>New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={resetData.newPassword}
                      onChange={(e) =>
                        setResetData({
                          ...resetData,
                          newPassword: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={resetData.confirmPassword}
                      onChange={(e) =>
                        setResetData({
                          ...resetData,
                          confirmPassword: e.target.value,
                        })
                      }
                    />
                  </div>

                  <button
                    type="button"
                    className="btn btn-success w-100 mb-2"
                    onClick={async () => {
                      try {
                        if (
                          !resetData.oldPassword ||
                          !resetData.newPassword ||
                          !resetData.confirmPassword
                        ) {
                          showPopup("Please fill all fields");
                          return;
                        }

                        if (passwordMode === "RESET" && !formData.accountNo) {
                          showPopup("Please enter Account Number");
                          return;
                        }

                        if (
                          resetData.newPassword !== resetData.confirmPassword
                        ) {
                          showPopup("Passwords do not match");
                          return;
                        }
                        if (resetData.newPassword.length < 8) {
                          showPopup(
                            "Password must be at least 8 characters long",
                          );
                          return;
                        }
                        if (resetData.oldPassword === resetData.newPassword) {
                          showPopup(
                            "New password cannot be same as current password",
                          );
                          return;
                        }
                        setLoading(true);

                        const accountNo =
                          passwordMode === "FIRST_LOGIN"
                            ? JSON.parse(sessionStorage.getItem("accountNo"))
                            : formData.accountNo;

                        const res = await fetch(
                          "https://smlsoc-backend-3.onrender.com/resetPassword",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              ...authHeader(), // ✅ NEW — only present for FIRST_LOGIN (post-login); empty for RESET (pre-login), see note
                            },
                            body: JSON.stringify({
                              accountNo,
                              oldPassword: resetData.oldPassword,
                              newPassword: resetData.newPassword,
                            }),
                          },
                        );

                        const result = await res.json();

                        if (!res.ok) {
                          throw new Error(
                            result.message || "Password change failed",
                          );
                        }

                        if (passwordMode === "FIRST_LOGIN") {
                          sessionStorage.setItem(
                            "isMemberLoggedIn",
                            JSON.stringify(true),
                          );

                          navigate("/memberDetails");
                        } else {
                          showPopup("Password reset successfully");

                          setViewMode("LOGIN");
                        }

                        setPasswordMode("");

                        setResetData({
                          oldPassword: "",
                          newPassword: "",
                          confirmPassword: "",
                        });
                      } catch (err) {
                        console.error(err);

                        showPopup(err.message || "Something went wrong");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    {loading
                      ? "Please wait..."
                      : passwordMode === "FIRST_LOGIN"
                        ? "Change Password"
                        : "Reset Password"}
                  </button>

                  {passwordMode === "FIRST_LOGIN" && (
                    <button
                      type="button"
                      className="btn btn-secondary w-100 mb-2"
                      onClick={async () => {
                        try {
                          setLoading(true);

                          const accountNo = JSON.parse(
                            sessionStorage.getItem("accountNo"),
                          );

                          const res = await fetch(
                            "https://smlsoc-backend-3.onrender.com/skipPasswordChange",
                            {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                              },
                              body: JSON.stringify({
                                accountNo,
                              }),
                            },
                          );

                          const data = await res.json();

                          if (!res.ok) {
                            throw new Error(
                              data.message || "Unable to continue",
                            );
                          }

                          sessionStorage.setItem(
                            "isMemberLoggedIn",
                            JSON.stringify(true),
                          );

                          navigate("/memberDetails");
                        } catch (err) {
                          showPopup(err.message || "Something went wrong");
                        } finally {
                          setLoading(false);
                        }
                      }}
                    >
                      Login Without Changing
                    </button>
                  )}

                  <button
                    className="btn btn-outline-dark w-100"
                    onClick={() => {
                      document
                        .querySelector(".card-wrapper")
                        ?.classList.remove("flipped");

                      setTimeout(() => {
                        setViewMode("LOGIN");
                        setPasswordMode("");

                        setResetData({
                          oldPassword: "",
                          newPassword: "",
                          confirmPassword: "",
                        });
                      }, 600);
                    }}
                  >
                    Back To Login
                  </button>
                </div>
              </div>
            )}
          </div>
          {loading && (
            <div className="loginloader-overlay">
              <div className="loginloader-content">
                <img src={logo} alt="center-img" className="static-image" />
                <div className="spinner-circle"></div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Popup
        isOpen={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
      />
    </>
  );
}

function AdminLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [popupMessage, setPopupMessage] = useState("");
  const [error] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const showPopup = (msg) => {
    setPopupMessage(msg);
    setPopupOpen(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(
        "https://smlsoc-backend-3.onrender.com/adminLogin",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );
      const loginResponse = await res.json();
      userData = loginResponse;
      const adminUserName = loginResponse.userName;
      if (!res.ok) throw new Error(loginResponse.message || "Login failed");
      if (sizeOf(adminUserName) > 0) {
        isAdminLoggedIn = true;
        sessionStorage.setItem("userData", JSON.stringify(userData));
        sessionStorage.setItem("token", JSON.stringify(loginResponse.token)); // ✅ NEW: save JWT from adminLogin response
        sessionStorage.setItem(
          "isAdminLoggedIn",
          JSON.stringify(isAdminLoggedIn),
        );
        return navigate("/upload");
      } else {
        setLoading(false);
        showPopup("Unable to Get details");
        navigate("/adminlogin");
      }
    } catch (err) {
      setLoading(false);
      showPopup(err.message || "Unable to login");
    }
  };

  return (
    <>
      <div className="auth-container">
        <div className="card-wrapper">
          {/* LOGIN FORM */}
          <div className="card-face">
            <div className="row g-0 align-items-center">
              <div className="col-md-6 d-none d-md-block">
                <img src={login} className="img-fluid" alt="Login" />
              </div>
              <div className="col-md-6 col-12 p-4">
                <h2 className="mb-4 text-center text-md-start">Admin Login</h2>
                <form onSubmit={handleLogin}>
                  <div className="mb-3">
                    <label>Username</label>
                    <input
                      type="text"
                      name="username"
                      className="form-control"
                      value={formData.username}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <div className="mb-3 position-relative">
                      <label>Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="form-control pe-5"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />

                      {/* Eye Icon */}
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "30px",
                          cursor: "pointer",
                          color: "black",
                          fontSize: "1.2rem",
                          transition: "opacity 0.3s ease",
                        }}
                      >
                        <i
                          className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                          style={{ transition: "opacity 0.3s ease" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                  {error && <div className="text-danger mb-3">{error}</div>}
                  <button className="btn btn-primary w-100" type="submit">
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>

          {loading && (
            <div className="loginloader-overlay">
              <div className="loginloader-content">
                <img src={logo} alt="center-img" className="static-image" />
                <div className="spinner-circle"></div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Popup
        isOpen={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
      />
    </>
  );
}
function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 5000);
      return () => clearTimeout(timer); // Cleanup on unmount or if re-triggered
    }
  }, [submitted]);
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("https://smlsoc-backend-3.onrender.com/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => res.text())
      .then((data) => {
        // alert(data);
        setSubmitted(true);
        setForm({ name: "", email: "", subject: "", message: "" });
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="container contact my-5">
      <div className="row align-items-center contact-wrapper">
        {/* Image - hidden on small devices */}
        <div className="col-md-5 d-none d-md-block">
          <div className="contact-image-wrapper">
            <img src={contactUs} alt="Contact Us" className="contact-image" />
          </div>
        </div>

        {/* Contact Form */}
        <div className="col-12 col-md-7 p-5">
          <h2 className="mb-4 fw-bold text-center">Contact Us</h2>
          {submitted ? (
            <div
              className="alert alert-success text-center alert-dismissible fade show"
              role="alert"
            >
              Thanks! We'll get back to you soon.
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setSubmitted(false)}
              ></button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Your Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Your Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    rows="4"
                    className="form-control"
                    value={form.message}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12">
                  <button type="submit" className="btn btn-primary w-100">
                    SUBMIT
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

function RouteLoaderWrapper({ children }) {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    // If it's not the first render, show the loader
    if (!firstRender.current) {
      setLoading(true);
    }

    const timer = setTimeout(() => {
      setLoading(false);
      firstRender.current = false;
    }, 500); // 2 seconds

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && <Loader />}
      {!loading && children}
    </>
  );
}
function BankDetails() {
  return (
    <>
      <div className="bankDetails">
        <div className="bankContent">
          <h2>ऑनलाईन ट्रांसफर या बैंक में जमा करने के लिए</h2>
          <br></br>
          <p>
            <b>Shree Maa Laxmi Co-Operative (U) Thrift & Credit Society Ltd.</b>
            <br />
            IDBI Bank Ltd. Saket
            <br />
            A/C No. 0110104000337076
            <br />
            IFSC Code - IBKL0000110
          </p>
          <p>
            <Play style={{ fill: "orange", stroke: "orange" }} size={23} /> राशि
            भेजने से पहले, कृपया यह सुनिश्चित करें कि प्राप्तकर्ता का नाम{" "}
            <b>Shree Maa Laxmi Co-Operative (U) Thrift & Credit Society Ltd.</b>{" "}
            ही है ।
          </p>
          <p>
            <Play size={15} style={{ fill: "orange", stroke: "orange" }} /> राशि
            भेजने के बाद, कृपया ट्रांजैक्शन का स्क्रीनशॉट, अपना मेम्बरशिप ID और
            पूरा नाम के साथ इस व्हाट्सएप नंबर पर भेजें ।<br></br>
            <Phone size={23} style={{ fill: "orange", stroke: "orange" }} /> :
            9810984250
          </p>
        </div>
        <div className="qr">
          <img className="qrImage" src={bankQR} alt="bankqr"></img>
        </div>
      </div>
    </>
  );
}

function Footer() {
  return (
    <footer className="bottom-bar foot">
      <div className="footer">
        <div className="flex-small">
          <div className="address">
            <p className="link">Office</p>
            <p></p>
            <b>
              <p>KH.NO.137/16/2, A1 Block, 1st Floor</p>
              <p>Sant Nagar, Burari</p>
              <p> Delhi-110084</p>
            </b>
            <br />
            <p>
              <b>Phone No:</b> 9810984250, 011-41808165
            </p>
          </div>
          <div className="Helpful1">
            <p className="link">Helpful Links</p>
            <Link to="/about" className="naked-link">
              About Us
            </Link>
            <Link to="/gallery" className="naked-link">
              Gallery
            </Link>
            {/* <Link to="/committee" className="naked-link">Committee</Link> */}
            <Link to="/contact" className="naked-link">
              Contact
            </Link>
            <Link to="/Login" className="naked-link">
              Login/Signup
            </Link>
          </div>
        </div>
        <div className="Helpful">
          <p className="link">Helpful Links</p>
          <Link to="/about" className="naked-link">
            About Us
          </Link>
          <Link to="/gallery" className="naked-link">
            Gallery
          </Link>
          {/* <Link to="/committee" className="naked-link">Committee</Link> */}
          <Link to="/contact" className="naked-link">
            Contact
          </Link>
          <Link to="/Login" className="naked-link">
            Login/Signup
          </Link>
        </div>
        <div className="our-services">
          <div>
            <h3 className="serviceH">Our Services</h3>
            <div className="sub-content">
              <div className="space">
                <h5 className="dservices">Loan service</h5>
                <Link to="/loan/emergencyLoan" className="naked-link">
                  Emergency Loan
                </Link>
                <Link to="/loan/personalLoan" className="naked-link">
                  Personal/Regular Loan
                </Link>
                <Link to="/loan/loanAgainstDeposit" className="naked-link">
                  Loan Againt Deposit
                </Link>
              </div>
              <div className="space">
                <h5 className="dservices">Deposit Service</h5>
                <Link to="/services/fixedDeposit" className="naked-link">
                  Fixed Deposit
                </Link>
                <Link to="/services/reccuringDeposit" className="naked-link">
                  Recurring Deposit
                </Link>
                <Link to="/services/savingDeposit" className="naked-link">
                  Saving Deposit
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-separator" />
      <div className="text-center">
        <b>
          &copy; {new Date().getFullYear()} Shree Maa Laxmi Cooperative Society
        </b>
      </div>
    </footer>
  );
}

function PersonalLoan() {
  return (
    <>
      <div className="container my-5">
        <div className="text-center mb-4 ">
          <h1>Personal Loan</h1>
          <h5>Maximum Amount: ₹1,00,000/-</h5>
        </div>
        <div className="services">
          <div className="row g-4">
            {/* Interest Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-int d-flex h-100">
                <div className="me-3">
                  <Percent size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Interest</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    15% p.a Reducing Balance
                  </p>
                </div>
              </div>
            </div>

            {/* Conditions Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-conditions d-flex h-100">
                <div className="me-3">
                  <FileText size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Conditions</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Must be a Member of the Society.
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Share Money and Compulsory Deposit (CD) shall be min. 10 %
                    each deposited into the account of the member.
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    2 Guarantor (Guarantor shall be the existing member of the
                    Society and should not be a defaulter)
                  </p>
                </div>
              </div>
            </div>

            {/* Documents Required Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-dr d-flex h-100">
                <div className="me-3">
                  <FileSignature size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Documents Required</h5>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Photo Id Proof (Any like Voter ID Card, Aadhar Card, Pan
                    Card etc.)
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Address Proof (Water/Electricity bill, Compulsory)
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Income Proof (3 years ITR, Salary Slip, Affidavit)
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    10 A/c Payee Cheques (CTS Cheques)
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    2 Latest Passport Size Photo.
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Rent Agreement (In case of tenant. Electricity/Water bill of
                    Landlord compulsory)
                  </p>
                </div>
              </div>
            </div>

            {/* Tenure & Charges Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-ltc d-flex h-100">
                <div className="me-3">
                  <Clock size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Loan Tenure & Charges</h5>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Loan Tenure will be max. of 36 months (3 year){" "}
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Non-payment of the instalment on Due date will incur 3%
                    penalty interest extra to the member.{" "}
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                    Processing Charges (3%){" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Calculator
        heading="Personal Loan Calculator"
        interestRate="15"
        period="12"
        amount="10000"
      />
    </>
  );
}

function EmergencyLoan() {
  return (
    <>
      <div className="container my-5">
        <div className="text-center mb-4">
          <h1>Emergency Loan</h1>
          <h5>Maximum Amount: ₹10,000/-</h5>
        </div>

        <div className="services">
          <div className="row g-4">
            {/* Interest Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-int d-flex h-100">
                <div className="me-3">
                  <Percent size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Interest</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    15% p.a Reducing Balance
                  </p>
                </div>
              </div>
            </div>

            {/* Conditions Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-conditions d-flex h-100">
                <div className="me-3">
                  <FileText size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Conditions</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Must be a Member of the Society.
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Share Money and CD min ₹5000/- each.
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    1 Guarantor (not a defaulter).
                  </p>
                </div>
              </div>
            </div>

            {/* Documents Required Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-dr d-flex h-100">
                <div className="me-3">
                  <FileSignature size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Documents Required</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Photo ID (Voter, Aadhar, PAN).
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Address Proof (Electric/Water bill).
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Rent Agreement & Landlord’s bill.
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    1 Passport Photo.
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    1 A/C Payee Cheque.
                  </p>
                </div>
              </div>
            </div>

            {/* Tenure & Charges Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-ltc d-flex h-100">
                <div className="me-3">
                  <Clock size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Loan Tenure & Charges</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Max tenure: 12 months
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    3% penalty for late payment
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Processing charges apply
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Calculator
          heading="Emergency loan Calculator"
          interestRate="15"
          period="12"
          amount="10000"
        />
      </div>
    </>
  );
}
function FixedDeposit() {
  return (
    <>
      <div className="container my-5">
        <div>
          <div className="text-center mb-4">
            <h1>Fixed Deposit Scheme</h1>
            <h5>Receive fixed return which maximise your return</h5>
          </div>
          <div className="services">
            <div className="row g-4">
              {/* Interest Card */}
              <div className="col-12 col-md-6">
                <div className="highlight-card-int d-flex h-100">
                  <div className="me-3">
                    <Percent size={32} color="orange" />
                  </div>
                  <div>
                    <h5 className="mb-2">Interest</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />{" "}
                      Intrest rate range is 7 to 8%
                    </p>
                  </div>
                </div>
              </div>

              {/* Conditions Card */}
              <div className="col-12 col-md-6">
                <div className="highlight-card-conditions d-flex h-100">
                  <div className="me-3">
                    <FileText size={32} color="orange" />
                  </div>
                  <div>
                    <h5 className="mb-2">Minimum Deposit Amount</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Rs.1000/- further is choice
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FixedDepositCalculator
            heading="Fixed Deposit Calculator"
            interestRate="8"
            period="24"
            amount="10000"
          />
        </div>
      </div>
    </>
  );
}
function RecurringDeposit() {
  return (
    <>
      <div className="container my-5">
        <div>
          <div className="text-center mb-4">
            <h1>Recurring Deposit Scheme</h1>
            <h5>Receive fixed return which maximise your return</h5>
          </div>
          <div className="services">
            <div className="row g-4">
              {/* Interest Card */}
              <div className="col-12 col-md-6">
                <div className="highlight-card-int d-flex h-100">
                  <div className="me-3">
                    <Percent size={32} color="orange" />
                  </div>
                  <div>
                    <h5 className="mb-2">Interest</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />{" "}
                      Intrest rate range is 7 to 8%
                    </p>
                  </div>
                </div>
              </div>

              {/* Conditions Card */}
              <div className="col-12 col-md-6">
                <div className="highlight-card-conditions d-flex h-100">
                  <div className="me-3">
                    <FileText size={32} color="orange" />
                  </div>
                  <div>
                    <h5 className="mb-2">Minimum Deposit Amount</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Rs.1000/- further is choice
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RecurringDepositCalculator
            heading="Recurring Deposit Calculator"
            interestRate="8"
            period="24"
            amount="10000"
          />
        </div>
      </div>
    </>
  );
}
function SavingDeposit() {
  return (
    <>
      <div className="container my-5">
        <div>
          <div className="text-center mb-4">
            <h1>Saving Deposit Scheme</h1>
            <h5>Receive fixed return which maximise your return</h5>
          </div>
          <div className="services">
            <div className="row g-4">
              {/* Interest Card */}
              <div className="col-12 col-md-6">
                <div className="highlight-card-int d-flex h-100">
                  <div className="me-3">
                    <UserCheck
                      size={32}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                  </div>
                  <div>
                    <h5 className="mb-2">Eligibility</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />{" "}
                      The applicant must be a member of the Society
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="highlight-card-conditions d-flex h-100">
                  <div className="me-3">
                    <IndianRupee
                      size={32}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                  </div>
                  <div>
                    <h5 className="mb-2">Minimum Deposit Amount</h5>
                    <p className="mb-1">
                      <Play
                        size={5}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Rs.1000/- further is choice
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="highlight-card-conditions d-flex h-100">
                  <div className="me-3">
                    <UserPlus
                      size={32}
                      style={{ fill: "orange", stroke: "orange" }}
                    />
                  </div>
                  <div>
                    <h5 className="mb-2">Nomination Facility</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Nomination Facility Available.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="highlight-card-conditions d-flex h-100">
                  <div className="me-3">
                    <Megaphone size={32} color="orange" />
                  </div>
                  <div>
                    <h5 className="mb-2">Special Features</h5>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      No TDS is applicable on the interest earned on deposits.
                    </p>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Offers higher interest rates.
                    </p>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Saving Account Passbook will be provided.
                    </p>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Any time deposit and withdrawal.
                    </p>
                    <p className="mb-1">
                      <Play
                        size={15}
                        style={{ fill: "orange", stroke: "orange" }}
                      />
                      Zero balance account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
function PaymentProcess() {
  return (
    <>
      <div className="paymentProcess">
        <h1>Payment Process</h1>
        <div className="payment-container">
          <div className="payment-step">
            <img className="payment-img" src={paymentHome} alt="Step 1" />
            <p className="payment-text">
              <b>Step-1</b>
            </p>
            <p className="payment-text">
              कोई भी UPI ऐप खोलें और QR code <br /> स्कैन करने के लिए क्लिक करें
              ।
            </p>
          </div>

          <div className="payment-step">
            <img className="payment-img" src={paymentScanner} alt="Step 2" />
            <p className="payment-text">
              <b>Step-2</b>
            </p>
            <p className="payment-text">QR code को स्कैन करें।</p>
          </div>

          <div className="payment-step">
            <img className="payment-img" src={paymentName} alt="Step 3" />
            <p className="payment-text">
              <b>Step-3</b>
            </p>
            <p className="payment-text">
              Society का नाम <br />
              Shree Maa Laxmi society <br /> check करें ।
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function LoanAgainstDeposit() {
  return (
    <>
      <div className="container my-5">
        <div className="text-center mb-4">
          <h1>Loan Against Deposit</h1>
          <h5>Max. Up to 90% of the deposits</h5>
        </div>
        <div className="services">
          <div className="row g-4">
            {/* Interest Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-int d-flex h-100">
                <div className="me-3">
                  <Percent size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Interest</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    As per your F.D rate + 3% Extra
                  </p>
                </div>
              </div>
            </div>

            {/* Conditions Card */}
            <div className="col-12 col-md-6">
              <div className="highlight-card-conditions d-flex h-100">
                <div className="me-3">
                  <FileText size={32} color="orange" />
                </div>
                <div>
                  <h5 className="mb-2">Conditions</h5>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Must be a Member of the Society.
                  </p>
                  <p className="mb-1">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Must produce the FD Certificate (in case of Loan against
                    FD).
                  </p>
                  <p className="mb-0">
                    <Play
                      size={15}
                      style={{ fill: "orange", stroke: "orange" }}
                    />{" "}
                    Must produce the original documents in case of Loan against
                    FD.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Calculator
          heading="Loan Against Deposit Calculator"
          interestRate="15"
          period="12"
          amount="10000"
        />
      </div>
    </>
  );
}

function Calculator(props) {
  const [loanAmount, setLoanAmount] = useState(props.amount || "");
  const [interestRate, setInterestRate] = useState(props.interestRate || "");
  const [rateType, setRateType] = useState("Yearly");
  const [loanTenure, setLoanTenure] = useState(props.period || "");

  const [emi, setEmi] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);

  const calculateEMI = () => {
    const principal = parseFloat(loanAmount);
    const months = parseInt(loanTenure);

    if (
      isNaN(principal) ||
      isNaN(months) ||
      months <= 0 ||
      isNaN(parseFloat(interestRate))
    ) {
      setEmi(0);
      setTotalInterest(0);
      setTotalPayment(0);
      return;
    }

    // Convert to monthly interest rate
    const monthlyRate =
      rateType === "Yearly"
        ? parseFloat(interestRate) / 12 / 100
        : parseFloat(interestRate) / 100;

    let emiAmount = 0;

    if (monthlyRate === 0) {
      emiAmount = principal / months;
    } else {
      emiAmount =
        (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);
    }

    const payment = emiAmount * months;
    const interest = payment - principal;

    setEmi(emiAmount.toFixed(2));
    setTotalInterest(interest.toFixed(2));
    setTotalPayment(payment.toFixed(2));
  };

  const clearFields = () => {
    setLoanAmount("");
    setInterestRate("");
    setLoanTenure("");
    setEmi(0);
    setTotalInterest(0);
    setTotalPayment(0);
  };

  return (
    <div className="container d-flex justify-content-center my-5">
      <div
        className="bg-light shadow-sm p-4 rounded"
        style={{
          maxWidth: "420px",
          backgroundColor: "#fff7f0",
        }}
      >
        <h5 className="text-center fw-bold mb-3">{props.heading}</h5>

        <hr />

        <div className="mb-3">
          <label className="form-label fw-semibold">Loan Amount (₹):</label>
          <input
            type="number"
            className="form-control"
            value={loanAmount}
            onChange={(e) => setLoanAmount(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Interest Rate:</label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={interestRate}
              onChange={(e) => setInterestRate(e.target.value)}
            />

            <select
              className="form-select"
              value={rateType}
              onChange={(e) => setRateType(e.target.value)}
            >
              <option value="Yearly">Yearly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Loan Tenure</label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={loanTenure}
              onChange={(e) => setLoanTenure(e.target.value)}
            />
            <span className="input-group-text">Months</span>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-warning text-white fw-bold px-4"
            onClick={calculateEMI}
          >
            Calculate
          </button>

          <button
            className="btn btn-light border fw-semibold"
            onClick={clearFields}
          >
            Clear
          </button>
        </div>

        <hr />

        <div className="mt-3">
          <div className="d-flex justify-content-between mb-2">
            <span>Monthly EMI</span>
            <strong>₹{Number(emi).toLocaleString()}</strong>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Total Interest</span>
            <strong>₹{Number(totalInterest).toLocaleString()}</strong>
          </div>

          <div className="d-flex justify-content-between">
            <span>Final Payment</span>
            <strong className="text-success">
              ₹{Number(totalPayment).toLocaleString()}
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
}

function FixedDepositCalculator(props) {
  const [loanAmount, setLoanAmount] = useState(props.amount || "");
  const [interestRate, setInterestRate] = useState(props.interestRate || "");
  const [rateType, setRateType] = useState("Yearly");
  const [loanTenure, setLoanTenure] = useState(props.period || "");

  const [maturityAmount, setMaturityAmount] = useState(0);
  const [interestEarned, setInterestEarned] = useState(0);

  const calculateFD = () => {
    const principal = parseFloat(loanAmount);
    const months = parseFloat(loanTenure);
    const rate = parseFloat(interestRate);

    if (!principal || !months || !rate) {
      setMaturityAmount(0);
      setInterestEarned(0);
      return;
    }

    const years = months / 12;
    const n = 1; // Quarterly Compounding

    const maturity = principal * Math.pow(1 + rate / (100 * n), n * years);

    const interest = maturity - principal;

    setInterestEarned(interest.toFixed(2));
    setMaturityAmount(maturity.toFixed(2));
  };

  const clearFields = () => {
    setLoanAmount("");
    setInterestRate("");
    setLoanTenure("");
    setMaturityAmount(0);
    setInterestEarned(0);
  };

  return (
    <div className="container d-flex justify-content-center my-5">
      <div
        className="bg-light shadow-sm p-4 rounded"
        style={{ maxWidth: "420px", backgroundColor: "#fff7f0" }}
      >
        <h5 className="text-center fw-bold mb-3">{props.heading}</h5>
        <hr />

        <div className="mb-3">
          <label className="form-label fw-semibold">Invested Amount (₹):</label>
          <input
            type="number"
            className="form-control"
            value={loanAmount}
            onChange={(e) => setLoanAmount(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Rate Of Interest:</label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={interestRate}
              onChange={(e) => setInterestRate(e.target.value)}
            />

            <select
              className="form-select"
              value={rateType}
              onChange={(e) => setRateType(e.target.value)}
            >
              <option value="Yearly">Yearly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">
            Time Period (Months):
          </label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={loanTenure}
              onChange={(e) => setLoanTenure(e.target.value)}
            />
            <span className="input-group-text">Months</span>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-warning text-white fw-bold px-4"
            onClick={calculateFD}
          >
            Calculate
          </button>

          <button
            className="btn btn-light border fw-semibold"
            onClick={clearFields}
          >
            Clear
          </button>
        </div>

        <hr />

        <div className="mt-3">
          <p className="mb-2">
            <strong>Interest Earned:</strong> ₹
            {Math.round(Number(interestEarned)).toLocaleString("en-IN")}
          </p>

          <h6 className="text-success">
            Estimated Maturity Amount: ₹
            {Math.round(Number(maturityAmount)).toLocaleString("en-IN")}
          </h6>
        </div>
      </div>
    </div>
  );
}

function RecurringDepositCalculator(props) {
  const [loanAmount, setLoanAmount] = useState(props.amount || "");
  const [interestRate, setInterestRate] = useState(props.interestRate || "");
  const [rateType, setRateType] = useState("Yearly");
  const [loanTenure, setLoanTenure] = useState(props.period || "");

  const [maturityAmount, setMaturityAmount] = useState(0);
  const [interestEarned, setInterestEarned] = useState(0);
  const [totalInvestment, setTotalInvestment] = useState(0);

  const calculateRD = () => {
    const monthlyDeposit = parseFloat(loanAmount);
    const months = parseInt(loanTenure);
    const annualRate = parseFloat(interestRate);

    if (!monthlyDeposit || !months || !annualRate) {
      setMaturityAmount(0);
      setInterestEarned(0);
      setTotalInvestment(0);
      return;
    }

    // Effective monthly rate based on yearly compounding
    const monthlyRate = Math.pow(1 + annualRate / 100, 1 / 12) - 1;

    const maturity =
      monthlyDeposit *
      (((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) *
        (1 + monthlyRate));

    const invested = monthlyDeposit * months;
    const interest = maturity - invested;

    setMaturityAmount(maturity.toFixed(2));
    setInterestEarned(interest.toFixed(2));
    setTotalInvestment(invested.toFixed(2));
  };

  const clearFields = () => {
    setLoanAmount("");
    setInterestRate("");
    setLoanTenure("");
    setMaturityAmount(0);
    setInterestEarned(0);
    setTotalInvestment(0);
  };

  return (
    <div className="container d-flex justify-content-center my-5">
      <div
        className="bg-light shadow-sm p-4 rounded"
        style={{ maxWidth: "420px", backgroundColor: "#fff7f0" }}
      >
        <h5 className="text-center fw-bold mb-3">{props.heading}</h5>
        <hr />

        <div className="mb-3">
          <label className="form-label fw-semibold">Monthly Deposit (₹):</label>
          <input
            type="number"
            className="form-control"
            value={loanAmount}
            onChange={(e) => setLoanAmount(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Rate Of Interest:</label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={interestRate}
              onChange={(e) => setInterestRate(e.target.value)}
            />

            <select
              className="form-select"
              value={rateType}
              onChange={(e) => setRateType(e.target.value)}
            >
              <option value="Yearly">Yearly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">
            Time Period (Months):
          </label>

          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={loanTenure}
              onChange={(e) => setLoanTenure(e.target.value)}
            />
            <span className="input-group-text">Months</span>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-warning text-white fw-bold px-4"
            onClick={calculateRD}
          >
            Calculate
          </button>

          <button
            className="btn btn-light border fw-semibold"
            onClick={clearFields}
          >
            Clear
          </button>
        </div>

        <hr />

        <div className="mt-3">
          <p className="mb-2">
            <strong>Total Investment:</strong> ₹
            {Math.round(Number(totalInvestment)).toLocaleString("en-IN")}
          </p>

          <p className="mb-2">
            <strong>Interest Earned:</strong> ₹
            {Math.round(Number(interestEarned)).toLocaleString("en-IN")}
          </p>

          <h6 className="text-success">
            Estimated Maturity Amount: ₹
            {Math.round(Number(maturityAmount)).toLocaleString("en-IN")}
          </h6>
        </div>
      </div>
    </div>
  );
}

function Circulars() {
  const [documents, setDocuments] = useState([]);

  const [expandedId, setExpandedId] = useState(null);

  const [showUpload, setShowUpload] = useState(false);

  const [showEdit, setShowEdit] = useState(false);

  const [viewer, setViewer] = useState(null);

  const [title, setTitle] = useState("");

  const [file, setFile] = useState(null);

  const [editId, setEditId] = useState("");

  const [editTitle, setEditTitle] = useState("");

  const [editFile, setEditFile] = useState(null);

  const MAX_SIZE = 50 * 1024 * 1024;

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const res = await axios.get(
        "https://smlsoc-backend-3.onrender.com/documents",
        {
          headers: authHeader(), // ✅ NEW — note: this route now requires login, see note above
        },
      );

      setDocuments(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleAccordion = (id) => {
    if (expandedId === id) setExpandedId(null);
    else setExpandedId(id);
  };

  const uploadDocument = async () => {
    if (!title) {
      alert("Enter document title");

      return;
    }

    if (!file) {
      alert("Choose a file");

      return;
    }

    if (file.size > MAX_SIZE) {
      alert("Maximum size is 50 MB");

      return;
    }

    const formData = new FormData();

    formData.append("title", title);

    formData.append("file", file);

    try {
      await axios.post(
        "https://smlsoc-backend-3.onrender.com/documentUpload",

        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...authHeader(), // ✅ NEW
          },
        },
      );

      setShowUpload(false);

      setTitle("");

      setFile(null);

      fetchDocuments();
    } catch (err) {
      console.log(err);
    }
  };

  const openEdit = (doc) => {
    setEditId(doc.id);

    setEditTitle(doc.title);

    setEditFile(null);

    setShowEdit(true);
  };

  const updateDocument = async () => {
    const formData = new FormData();

    formData.append("title", editTitle);

    if (editFile) formData.append("file", editFile);

    try {
      await axios.put(
        `https://smlsoc-backend-3.onrender.com/documentUpdate/${editId}`,

        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            ...authHeader(), // ✅ NEW
          },
        },
      );

      setShowEdit(false);

      fetchDocuments();
    } catch (err) {
      console.log(err);
    }
  };

  const deleteDocument = async (id) => {
    if (!window.confirm("Delete this document?")) return;

    try {
      await axios.delete(
        `https://smlsoc-backend-3.onrender.com/documentDelete/${id}`,
        {
          headers: authHeader(), // ✅ NEW
        },
      );

      fetchDocuments();
    } catch (err) {
      console.log(err);
    }
  };

  const openViewer = (doc) => {
    setViewer(doc);
  };

  const closeViewer = () => {
    setViewer(null);
  };

  const getSource = (doc) => {
    return `data:${doc.mimeType};base64,${doc.document}`;
  };
  return (
    <>
      {/* ================= FULL PAGE VIEWER ================= */}

      {viewer && (
        <div className="documentViewer">
          <div className="viewerHeader">
            <button className="backBtn" onClick={closeViewer}>
              ← Back
            </button>

            <h4>{viewer.title}</h4>
          </div>

          {viewer.mimeType === "application/pdf" ? (
            <iframe
              title="PDF Viewer"
              src={getSource(viewer)}
              className="viewerFrame"
            />
          ) : (
            <img
              src={getSource(viewer)}
              alt={viewer.title}
              className="viewerImage"
            />
          )}
        </div>
      )}

      {!viewer && (
        <div className="documentsContainer">
          <div className="documentHeader">
            <div>
              <h2>📄 Circulars</h2>

              <p>Circulars, Notices, Declarations and Society Documents</p>
            </div>

            {isAdminLoggedIn && (
              <button className="addBtn" onClick={() => setShowUpload(true)}>
                + Add Document
              </button>
            )}
          </div>

          {documents.length === 0 && (
            <div className="emptyDocuments">No Documents Uploaded</div>
          )}

          {documents.map((doc) => (
            <div className="documentCard" key={doc.id}>
              <div
                className="documentTitle"
                onClick={() => toggleAccordion(doc.id)}
              >
                <span>{doc.title}</span>

                <span
                  className={expandedId === doc.id ? "arrow rotate" : "arrow"}
                >
                  ▼
                </span>
              </div>

              <div
                className={
                  expandedId === doc.id ? "documentBody open" : "documentBody"
                }
              >
                <div className="previewBox">
                  {doc.mimeType === "application/pdf" ? (
                    <iframe
                      title={doc.title}
                      src={getSource(doc)}
                      className="previewFrame"
                    />
                  ) : (
                    <img
                      src={getSource(doc)}
                      alt={doc.title}
                      className="previewImage"
                    />
                  )}
                </div>

                <div className="buttonRow">
                  <button className="openBtn" onClick={() => openViewer(doc)}>
                    Open Full Page
                  </button>

                  <a
                    href={getSource(doc)}
                    download={doc.title}
                    className="downloadBtn"
                  >
                    Download
                  </a>

                  {isAdminLoggedIn && (
                    <>
                      <button className="editBtn" onClick={() => openEdit(doc)}>
                        Edit
                      </button>

                      <button
                        className="deleteBtn"
                        onClick={() => deleteDocument(doc.id)}
                      >
                        Delete
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= UPLOAD MODAL ================= */}

      {showUpload && (
        <div className="modalOverlay">
          <div className="modalBox">
            <h3>Upload Document</h3>

            <input
              type="text"
              placeholder="Document Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.webp"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <div className="modalButtons">
              <button className="saveBtn" onClick={uploadDocument}>
                Save
              </button>

              <button
                className="cancelBtn"
                onClick={() => setShowUpload(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= EDIT MODAL ================= */}

      {showEdit && (
        <div className="modalOverlay">
          <div className="modalBox">
            <h3>Edit Document</h3>

            <input
              type="text"
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
            />

            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.webp"
              onChange={(e) => setEditFile(e.target.files[0])}
            />

            <div className="modalButtons">
              <button className="saveBtn" onClick={updateDocument}>
                Update
              </button>

              <button className="cancelBtn" onClick={() => setShowEdit(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Router>
        <RouteLoaderWrapper>
          <>
            <Navbar />
            <main className="flex-grow-1 main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/committee" element={<ManagingCommittee />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/adminlogin" element={<AdminLogin />} />
                <Route path="/memberDetails" element={<MemberDetails />} />
                <Route path="/upload" element={<UploadCSV />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/loan/emergencyLoan" element={<EmergencyLoan />} />
                <Route path="/Circulars" element={<Circulars />} />
                <Route
                  path="/loan/loanAgainstDeposit"
                  element={<LoanAgainstDeposit />}
                />
                <Route path="/loan/personalLoan" element={<PersonalLoan />} />
                <Route
                  path="/services/fixedDeposit"
                  element={<FixedDeposit />}
                />
                <Route
                  path="/services/recurringDeposit"
                  element={<RecurringDeposit />}
                />
                <Route
                  path="/services/savingDeposit"
                  element={<SavingDeposit />}
                />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Routes>
            </main>
            <Footer />
          </>
        </RouteLoaderWrapper>
      </Router>
    </div>
  );
}
